"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactMultiCarousel = _interopRequireDefault(require("react-multi-carousel"));

require("react-multi-carousel/lib/styles.css");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../../../utils");

var _Header = _interopRequireDefault(require("../../../Card/Header"));

var _Book = _interopRequireDefault(require("../Book"));

var _constants = require("./constants");

require("./style.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
* Container Component to view `LibraryBook`s.
*/
var LibraryShelf =
/*#__PURE__*/
function (_Component) {
  _inherits(LibraryShelf, _Component);

  function LibraryShelf() {
    _classCallCheck(this, LibraryShelf);

    return _possibleConstructorReturn(this, _getPrototypeOf(LibraryShelf).apply(this, arguments));
  }

  _createClass(LibraryShelf, [{
    key: "renderBooks",
    value: function renderBooks(items) {
      var onSelect = this.props.onSelect;
      return items.map(function (book) {
        var _book$color = book.color,
            color = _book$color === void 0 ? {} : _book$color,
            contribution = book.contribution,
            description = book.description,
            instance = book.instance,
            label = book.label;
        var accent = color.accent,
            cover = color.cover,
            text = color.text;
        return _react.default.createElement(_Book.default, {
          onClick: function onClick() {
            return onSelect(book);
          },
          title: label,
          subtitle: instance,
          detail: "Contribution: ".concat(contribution),
          accentColor: accent,
          coverColor: cover,
          textColor: text
        });
      });
    }
  }, {
    key: "renderCarousels",
    value: function renderCarousels() {
      var _this = this;

      var _this$props = this.props,
          graphic = _this$props.graphic,
          items = _this$props.items;
      var carousels = [];
      (0, _utils.chunk)(items, 10, function (itemChunk) {
        var isSmallCarousel = itemChunk.length < _constants.responsive.tablet.items;
        carousels.push(_react.default.createElement(_reactMultiCarousel.default, {
          responsive: _constants.responsive,
          ssr: true,
          swipeable: !isSmallCarousel,
          draggable: !isSmallCarousel,
          infinite: !isSmallCarousel,
          arrows: !isSmallCarousel,
          autoPlay: !isSmallCarousel,
          autoPlaySpeed: 9000 + Math.floor(Math.random() * 2000),
          keyBoardControl: true,
          containerClass: "story-library-shelf__carousel"
        }, _this.renderBooks(itemChunk)));

        if (graphic) {
          carousels.push(_react.default.createElement("div", {
            className: "story-library-shelf__graphic"
          }, _react.default.createElement("img", {
            src: graphic.url
          })));
        }
      });
      return carousels;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          style = _this$props2.style,
          title = _this$props2.title;
      return _react.default.createElement("div", {
        className: "story-library-shelf",
        style: style
      }, _react.default.createElement(_Header.default, {
        text: title
      }), this.renderCarousels());
    }
  }]);

  return LibraryShelf;
}(_react.Component);

exports.default = LibraryShelf;

_defineProperty(LibraryShelf, "propTypes", {
  /** Determines what media asset to render under the `Carousel` */
  graphic: _propTypes.default.object,

  /** Data to render `LibraryBook` props */
  items: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,

  /** Click handler callback used by the `LibraryShelf` */
  onSelect: _propTypes.default.func,

  /** Styling object of the `Shelf` */
  style: _propTypes.default.object,

  /** Header text to place above the `Shelf` */
  title: _propTypes.default.string
});

_defineProperty(LibraryShelf, "defaultProps", {
  onSelect: function onSelect() {},
  style: {}
});